<template>
  <div v-if="desktopTagging || mobileTagging" class="header-link--tagging" v-tag:useractionevent="taggingEvent">
    <slot/>
  </div>
  <div v-else class="header-link--tagging">
    <slot/>
  </div>
</template>

<script>
  import { tag } from '@Foundation/analyticsHandler';
  export default {
    name: 'header-link',
    directives: {
      tag
    },
    props: {
      desktopTagging: {
        required: false,
        type: Object,
        default: undefined
      },
      mobileTagging: {
        required: false,
        type: Object,
        default: undefined
      }
    },
    data() {
      return {
        smallScreen: !window.matchMedia('(min-width: 768px)').matches,
      };
    },
    computed: {
      taggingEvent() {
        return this.smallScreen ? this.mobileTagging : this.desktopTagging;
      }
    }
  };
</script>
